import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExpandableSection } from '../section-wrapper'
import { FormGroup, Select } from '../shared-styles'
import type { SettingsModalLogic } from '../../logic'

interface LanguageSectionProps {
    logic: SettingsModalLogic
    state: { language: string }
    expanded: boolean
    onToggle: () => void
    showTitleInSection?: boolean
}

const LANGUAGE_OPTIONS = [
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' },
]

export const LanguageSection: React.FC<LanguageSectionProps> = ({
    logic,
    state,
    expanded,
    onToggle,
    showTitleInSection = true,
}) => {
    const { t } = useTranslation('settings')
    return (
        <ExpandableSection
            iconName="globe"
            title={t('sections.language.title')}
            description={t('sections.language.description')}
            expanded={expanded}
            onToggle={onToggle}
            showTitleInSection={showTitleInSection}
        >
            <FormGroup>
                <Select
                    id="language"
                    value={state.language}
                    onChange={(e) => logic.updateLanguage(e.target.value)}
                >
                    {LANGUAGE_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Select>
            </FormGroup>
        </ExpandableSection>
    )
}
